// extracted by mini-css-extract-plugin
module.exports = {"imageSliderContainer":"ImageSlider_imageSliderContainer__3KcN7","imageSlider":"ImageSlider_imageSlider__JiAiu"};